import React from 'react';

import Button from '@/core/components/Button';
import type { ConversationsAction } from '@/core/lib/new-architecture/domain/donation.domain';
import { useRouterContext } from '@/core/lib/router/router.context';
import Routes from '@/core/lib/router/routes';
import { useTranslationContext } from '@/core/lib/translation/translation.context';

interface ConversationsActionComponentProps {
  action: ConversationsAction;
}

const ConversationsActionComponent: React.FC<ConversationsActionComponentProps> = ({ action }) => {
  const { t } = useTranslationContext(['common']);
  const { push } = useRouterContext();

  const href = new Routes.ConversationsRoute({
    donations: [action.donationId],
  });

  const onClick = () => {
    push(href);
  };

  return (
    <Button onClick={onClick} variant="primary" size="large" isDisabled={!action.sollicitations} iconLeft="message-square">
      {t(action.text, { ns: 'common', count: action.sollicitations })}
    </Button>
  );
};

export default ConversationsActionComponent;
